import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
function Stars() {
  return <div className="flex gap-1 mb-4" data-id="element-266">
      <StarIcon className="w-5 h-5 text-gold fill-gold" data-id="element-267" />
      <StarIcon className="w-5 h-5 text-gold fill-gold" data-id="element-268" />
      <StarIcon className="w-5 h-5 text-gold fill-gold" data-id="element-269" />
      <StarIcon className="w-5 h-5 text-gold fill-gold" data-id="element-270" />
      <StarIcon className="w-5 h-5 text-gold fill-gold" data-id="element-271" />
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full py-16 md:py-24 px-4 sm:px-6 bg-carbon" data-id="element-272">
      <div className="max-w-5xl mx-auto" data-id="element-273">
        <motion.h2 className="text-gold text-3xl sm:text-4xl lg:text-5xl font-bold mb-12 md:mb-16 text-center leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-274">
          Lo que dicen las empresas de Moving que ya usan el sistema
        </motion.h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-275">
          <motion.div variants={cardVariants} className="bg-surface border-l-4 border-l-gold border border-border rounded-xl p-6 sm:p-8 flex flex-col" data-id="element-276">
            <Stars data-id="element-277" />
            <blockquote className="text-light text-base sm:text-lg leading-relaxed mb-6 flex-1" data-id="element-278">
              "En 6 semanas pasamos de 3 mudanzas semanales a 11. Y casi todas
              con depósito pagado."
            </blockquote>
            <p className="text-gold font-semibold text-sm" data-id="element-279">Carlos M.</p>
            <p className="text-muted text-sm" data-id="element-280">Miami Moving Co.</p>
          </motion.div>

          <motion.div variants={cardVariants} className="bg-surface border-l-4 border-l-gold border border-border rounded-xl p-6 sm:p-8 flex flex-col" data-id="element-281">
            <Stars data-id="element-282" />
            <blockquote className="text-light text-base sm:text-lg leading-relaxed mb-6 flex-1" data-id="element-283">
              "Dejé de pelear por precio. Ahora mis clientes llegan preguntando
              por disponibilidad, no por descuentos."
            </blockquote>
            <p className="text-gold font-semibold text-sm" data-id="element-284">Roberto A.</p>
            <p className="text-muted text-sm" data-id="element-285">Premier Movers TX</p>
          </motion.div>

          <motion.div variants={cardVariants} className="bg-surface border-l-4 border-l-gold border border-border rounded-xl p-6 sm:p-8 flex flex-col" data-id="element-286">
            <Stars data-id="element-287" />
            <blockquote className="text-light text-base sm:text-lg leading-relaxed mb-6 flex-1" data-id="element-288">
              "El sistema de reputación nos salvó después de dos malas reseñas
              falsas. Hoy tenemos 4.9 estrellas."
            </blockquote>
            <p className="text-gold font-semibold text-sm" data-id="element-289">Diana L.</p>
            <p className="text-muted text-sm" data-id="element-290">Elite Relocation FL</p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}